import { Box, Separator } from "@salestrak/ui";

import { FormsListPanel } from "#app/components/forms/forms-list-panel";
import { PageHeader } from "#app/components/page-header";

export function FormsScreen() {
  return (
    <Box direction="column" fill="flex">
      <PageHeader title="Forms" />
      <Separator />
      <FormsListPanel />
    </Box>
  );
}
